import { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  FormControl,
  FormLabel,
  Input,
} from "@chakra-ui/react";

export default function CreateFolder({
  OnSubmit = () => {},
  IsLoading = false,
  OnClose = () => {},
  IsOpen = false,
  ParentId = null,
  texts = {} 
}) {
  const fileManagerTexts = texts?.fileManager || {};
  const generalTexts = texts?.general || {};
  
  const [Name, SetName] = useState("");

  const OnSubmitData = async (Name) => {
    const success = await OnSubmit({
      FolderName: Name,
      ParentId,
      Tab: "Create",
    });
    if (success) {
      OnClose();
    }
  };

  useEffect(() => {
    if (!IsOpen) {
      SetName("");
    }
  }, [IsOpen]);

  return (
    <Modal isOpen={IsOpen} onClose={OnClose} isCentered={true}>
      <ModalOverlay />
      <ModalContent
        as={"form"}
        onSubmit={(e) => {
          e.preventDefault();
          OnSubmitData(Name);
        }}
        className="MainModel"
      >
        <ModalHeader>{fileManagerTexts.createFolder || "Create Folder"}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl isRequired>
            <FormLabel>{fileManagerTexts.folderName || "Folder Name"}</FormLabel>
            <Input
              value={Name}
              onChange={(e) => SetName(e.target.value)}
              placeholder={fileManagerTexts.enterFolderName || "Enter folder name"}
              autoFocus
            />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button
            type="submit"
            colorScheme="blue"
            mr={3}
            isLoading={IsLoading}
            isDisabled={IsLoading || !Name}
            loadingText={generalTexts.SAVING || "Saving..."}
          >
            {generalTexts.save || "Save"}
          </Button>
          <Button variant="ghost" onClick={OnClose}>
            {generalTexts.cancel || "Cancel"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}